
import React, { useRef, useState, useEffect } from "react";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";





import { db } from "../config/firebase";
import AttachImageButton from "./chatbot/AttachImageButton";
import { SendHorizontal } from "lucide-react";
import { AUTO_GREETING_TEXT } from "../config/widgetDefaults";
import { uploadChatImage, validateChatImage } from "../utils/uploadChatImage";
import { analyseImageAndPostReply } from "../utils/requestImageAnalysis";


const urlParams = new URLSearchParams(window.location.search);
const currentDomain = urlParams.get("parentUrl");


function Chatfooter(props) {
    const [localdata, setlocaldata] = useState("");
  const [formValue, setFormValue] = useState("");
  const [attachedImage, setAttachedImage] = useState(null);
  const [attachedImagePreviewUrl, setAttachedImagePreviewUrl] = useState(null);
  const [attachError, setAttachError] = useState(null);
  const scrollref=useRef(null)

  // Validates the picked/captured image and stores it (with a local preview) until the user sends it.
  const handleImageSelected = (file) => {
    const validationError = validateChatImage(file);
    if (validationError) {
      setAttachError(validationError);
      return;
    }
    if (attachedImagePreviewUrl) URL.revokeObjectURL(attachedImagePreviewUrl);
    setAttachError(null);
    setAttachedImage(file);
    setAttachedImagePreviewUrl(URL.createObjectURL(file));
  };

  // Removes the pending image attachment and frees its preview URL.
  const clearAttachedImage = () => {
    if (attachedImagePreviewUrl) URL.revokeObjectURL(attachedImagePreviewUrl);
    setAttachedImage(null);
    setAttachedImagePreviewUrl(null);
  };

  // Immediately sends an image picked from the welcome screen's photo cards.
  useEffect(() => {
    if (!props.imageToSendNow) return;
    const imageFromWelcome = props.imageToSendNow;
    props.onImageToSendNowHandled();
    const validationError = validateChatImage(imageFromWelcome);
    if (validationError) {
      setAttachError(validationError);
      return;
    }
    setAttachError(null);
    // Show the photo in the chat straight away from the device while it uploads.
    props.onLocalImagePreviewChange?.(URL.createObjectURL(imageFromWelcome));
    handlechange({ preventDefault: () => {} }, imageFromWelcome);
  }, [props.imageToSendNow]); // eslint-disable-line react-hooks/exhaustive-deps -- react only to a newly picked welcome image

  const currentTime = new Date();
  let hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; 
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const month = String(currentTime.getMonth() + 1).padStart(2, "0"); // +1 because getMonth() is 0-indexed
  const day = String(currentTime.getDate()).padStart(2, "0");
  const year = currentTime.getFullYear();
  const currentTimeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
  const seconds = currentTime.getSeconds();

  const date_string= `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
  const { isLoading, setIsLoading, setShowChatHistory, setStartNewChat, startNewChat } =
    props;
 
  let photoURL = "testing";
  function getCurrentISTDate() {
    const date = new Date();

    // Convert the current date to IST by adding the IST offset
    const utcOffset = date.getTimezoneOffset(); // Offset in minutes
    const istOffset = 330; // IST offset in minutes (UTC+5:30)
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);

    // Get the year, month, and day
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
}
useEffect(()=>{
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if(scrollref.current && !isMobile){
    scrollref.current.focus()
  }
}, [])

console.log("IS loading ---------------",isLoading);
useEffect(() => {
  if (startNewChat) {
    const data_var=currentDomain+"myData"
 
    localStorage.removeItem(data_var);
    // setStartNewChat(false);  // Set startNewChat back to false
  }
}, [startNewChat, setStartNewChat]); 



  // Sends the typed text and/or an image (the footer attachment, or imageToSendNow when given) to Firestore and the bot server.
  const handlechange = async (e, imageToSendNow = null) => {
    const imageToSend = imageToSendNow || attachedImage;
    const urlParams = new URLSearchParams(window.location.search);
    const currentDomain = urlParams.get("parentUrl");
    const channel = urlParams.get("channel") || "Web";
     const shopId =
       currentDomain || "null";
       
// Helper function to set cookies with 30-day expiration
function setCookie(name, value, days = 30) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length)); // 👈 decode here
    }
  }
  return null;
}

// Your modified code
const uidvar = currentDomain + "uid";
let uid = getCookie(uidvar) || "";

e.preventDefault();
var docid = "";
const data_var = currentDomain + "myData";
const storedData = getCookie(data_var);

if (!formValue && !imageToSend) return;

setIsLoading(true);
setFormValue("Replying...");

if (!storedData) {
    // If the data is not already stored, set the initial data
    const initialData = { key: uid + Date.now().toString() };
    
    setCookie(data_var, JSON.stringify(initialData));
    
    docid = initialData.key;
} else {
    // If the data is already stored, parse it
    const parsedData = JSON.parse(storedData);
    
    docid = parsedData.key;
}

    let uploadedImageUrl = null;
    if (imageToSend) {
      try {
        uploadedImageUrl = await uploadChatImage(imageToSend, shopId, docid);
        if (!imageToSendNow) clearAttachedImage();
      } catch (uploadError) {
        console.error("Image upload failed:", uploadError);
        setAttachError("Couldn't upload the image. Please try again.");
        if (imageToSendNow) props.onLocalImagePreviewChange?.(null);
        setIsLoading(false);
        setFormValue(formValue);
        return;
      }
    }

    const userMessageEntry = {
      user: formValue,
      user_timestamp: date_string,
      time: currentTimeString,
      ...(uploadedImageUrl && { image_url: uploadedImageUrl }),
    };

    const newarray = [
      {
        server: false,
        text: formValue,
        image_url: uploadedImageUrl,
        photoURL: "icon.png",
        uid: uid,
        time: currentTimeString,
        timestamp: Date.now(),
      },
    ];
    props.messageupdate(newarray);
    const docRef = doc(db, "Messages", docid);
    // Use addDoc to add a new document to the "users" collection
    const docSnap = await getDoc(docRef);
    let assigned_to="bot@krunk.ai"
    if (docSnap.exists()) {
      
      var message = docSnap.data().Messages;
      assigned_to= docSnap.data().assigned_to || "bot@krunk.ai" ;
      var lastmessage2 = message[message.length - 1];
      if (lastmessage2["server"] !== undefined) {
        message.push(userMessageEntry);
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated:serverTimestamp(),
          
        }, { merge: true });
      } else {
        message.push(userMessageEntry);
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated:serverTimestamp(),
        }, { merge: true });
      }


      
    } else {
      // docSnap.data() will be undefined in this case
      
      await setDoc(docRef, {
        Chat_Status:"Open",
        Fetch_Firestore:true,
        Messages: [{server:AUTO_GREETING_TEXT,server_timestamp:date_string},userMessageEntry],
        server: false,
        user_id: uid,
        shop_id: shopId,
        User_Channel: "Web",
        timestamp: Date.now(),
        photoURL,
        ticket_id:docid,
        assigned_to:"bot@krunk.ai",
        doc_id:docid,
        User_Timestamp:getCurrentISTDate(),
        created_at:serverTimestamp(),
        last_updated:serverTimestamp(),
      }, { merge: true });
    }
    // The saved message (with the uploaded image) now comes through Firestore, so drop the local preview.
    if (imageToSendNow) props.onLocalImagePreviewChange?.(null);
 
    var url=""
  
    if(shopId == "null"){
      //  url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
      url='http://127.0.0.1:8080/server?docid='+docid+"&shop_id="+"Krunk.ai";
      
      // url='https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
    }
   else if(shopId == "Krunk.ai"){
      // 
    url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+docid+"&shop_id="+"Krunk.ai";
    }
else    if(shopId== "HomesterOnboardingProperties"){
 url='https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"Krunk.ai";
    }
  else  if(shopId == "JustWravels")
   {
      url='https://justwravel-bot-code.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
    url = "http://127.0.0.1:8080/server?docid="+  docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
   }
  else   if(shopId == "DivineHindu")
   {
    url='https://divine-hindu-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
   }
// else   if(shopId == "smilenbeauty"){
//      url='https://smile-n-beauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
//    }
else    if(shopId=="YaanMan"){
          url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
       
        }
        if(shopId == "smilenbeauty"){
 url='https://test-smilenbeauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid;
       
        }
        if(shopId == "headsupfortails.myshopify.com"){
          // url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;
        url="http://127.0.0.1:8080/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;

        }
        else{
            //  url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
  // url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;
      // url='https://justwravel-bot-code.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
     url="http://127.0.0.1:8080/server?docid="+ docid+ "&shop_id=" +shopId+ "&user_message="+`${formValue} `;
// url='https://test-smilenbeauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid;
  
}
    // const url="https://version-2-llm-371280248581.asia-south1.run.app/"+docid;
    //  const url = "http://127.0.0.1:8080/" + docid;
    //  let url = "https://chat-app-art-w4axif2xma-el.a.run.app/" + docid;
    // let url=""
     const parenturl = urlParams.get('parentUrl')?.trim().toLowerCase();
    //  const allowedUrls = ["test.gamenation", "gamenation.in","gradcapital","cottoncandywala.in"];
    //  console.log(parenturl)

     
    //  if(parenturl ){
    //   url="https://whatsappbot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/?docid="+docid+"&shop_id="+parenturl;
    // }
    //  if (channel && channel.trim().toLowerCase() === "shopify") {
    //   url = "https://shopify-backend-371280248581.asia-south1.run.app/" + docid;
    // }
    if (uploadedImageUrl) {
      url += "&image_url=" + encodeURIComponent(uploadedImageUrl);
    }
    // Photos go to the image-analysis endpoint (when configured) instead of the text bot server.
    if (uploadedImageUrl && props.imageAnalysisUrl && assigned_to == "bot@krunk.ai") {
      try {
        await analyseImageAndPostReply({
          analysisUrl: props.imageAnalysisUrl,
          imageUrl: uploadedImageUrl,
          docid,
          shopId,
        });
      } finally {
        setIsLoading(false);
        setFormValue("");
      }
      return;
    }
      if(assigned_to == "bot@krunk.ai"){
          fetch(url,{ method: 'GET'})
      .then((hello) => {
        console.log("URL is fetched");
      })
      .catch((err) => {
        console.log("No check");
      })
      .finally(() => {
        setIsLoading(false);
        setFormValue("");
      });
    }



   

    e.preventDefault();

    // setIsLoading(false);
  };

return (
  <div className=" krunk-text-textcolor  krunk-mt-0 krunk-px-2 krunk-pt-1 krunk-rounded-b-xl">
    {attachedImagePreviewUrl && (
      <div className="krunk-relative krunk-inline-block krunk-mb-1 krunk-ml-1">
        <img
          src={attachedImagePreviewUrl}
          alt="Attached"
          className="krunk-h-16 krunk-w-16 krunk-object-cover krunk-rounded-lg krunk-border krunk-border-gray-200"
        />
        {!isLoading && (
          <button
            type="button"
            onClick={clearAttachedImage}
            aria-label="Remove image"
            className="krunk-absolute krunk--top-2 krunk--right-2 krunk-w-5 krunk-h-5 krunk-flex krunk-items-center krunk-justify-center krunk-rounded-full krunk-bg-black krunk-text-white krunk-text-xs"
          >
            ×
          </button>
        )}
      </div>
    )}
    {attachError && (
      <p className="krunk-text-xs krunk-text-red-600 krunk-mb-1 krunk-ml-1">{attachError}</p>
    )}
    {/* hideTextInput keeps only the send logic (e.g. welcome-screen photos) and any error line visible */}
    {!props.hideTextInput && (<>
    <form
      className="krunk-flex krunk-items-center krunk-gap-2 krunk-py-2"
      onSubmit={handlechange}
    >
      <input
        type="text"
        className="krunk-flex-1 krunk-min-w-0 krunk-h-11 krunk-px-5 krunk-rounded-full krunk-bg-white krunk-border krunk-border-gray-200 krunk-outline-none krunk-text-sm krunk-text-black placeholder:krunk-text-gray-400 focus:krunk-border-buttonbackground disabled:krunk-text-gray-400"
        placeholder={attachedImage ? "Add a note (optional)..." : "Type a message..."}
        onChange={(e) => setFormValue(e.target.value)}
        value={formValue}
        disabled={isLoading}
        ref={scrollref}
      />

      {props.imageUploadEnabled && (
        <AttachImageButton onImageSelected={handleImageSelected} disabled={isLoading} />
      )}

      <button
        type="submit"
        aria-label="Send message"
        disabled={isLoading || (!formValue && !attachedImage)}
        className="krunk-flex-shrink-0 krunk-flex krunk-items-center krunk-justify-center krunk-w-10 krunk-h-10 krunk-rounded-full krunk-bg-buttonbackground krunk-text-white krunk-transition-opacity hover:krunk-opacity-90 disabled:krunk-opacity-40"
      >
        <SendHorizontal className="krunk-w-5 krunk-h-5" />
      </button>
    </form>
    
    <div className="krunk-flex krunk-items-center krunk-justify-center krunk-gap-1 krunk-text-xs krunk-pt-1 krunk-pb-0">
      <h1>
        <span className="krunk-text-headertextcolor">Powered by</span>{" "}
        <span className="krunk-text-headertextcolor ">Krunk.ai</span>{" "}
      </h1>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FLogo.svg?alt=media&token=5e4d9440-9ded-426e-be00-e82624f1b6f2"
        alt=""
        className="krunk-w-4"
      />
    </div>
    </>)}
  </div>
);
}

export default Chatfooter;